<template>
  <main-layout>
    <div class="page-container">
      <h1 class="heading-1">Applications</h1>
      <ul class="app-list">
        <li><router-link :to="{ name: 'hourimport' }">ADP hour import</router-link></li>
        <li><router-link :to="{ name: 'invoicing' }">Invoicing</router-link></li>
        <li><router-link :to="{ name: 'invoicing' }">Hubspot project number integration</router-link></li>
      </ul>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout"

export default {
  name: "DashPage",
  created() {
    this.$emit("update:layout", MainLayout)
  },
  components: {
    MainLayout
  }
}
</script>

<style lang="scss" scoped>
.app-list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    @include type-setting(0);
    padding: $base-padding 0;
    border-bottom: 1px solid $brand-green;
    cursor: pointer;
    &:hover {
      background-color: $brand-green-light;
    }
  }
}
</style>
